import {
    LOAD_BOOKINGS,
    LOAD_BOOKINGS_FAILURE,
    LOAD_BOOKINGS_SUCCESS,
} from '../actions';
import { UPDATE_BOOKING_FIELD } from '../actions/Bookings';

const initialState = {
    fetching: false,
    error: undefined,
    meta: {
        count: 0,
        previous: null,
        next: null,
        status_code: undefined,
    },
    content: [],
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_BOOKINGS:
            return {
                ...state,
                error: undefined,
                fetching: true,
            };
        case LOAD_BOOKINGS_FAILURE:
            return {
                ...state,
                error: action.payload,
                fetching: false,
            };
        case LOAD_BOOKINGS_SUCCESS:
            return {
                ...state,
                fetching: false,
                error: undefined,
                content: action.payload.content,
                meta: action.payload.meta,
            };
        case UPDATE_BOOKING_FIELD:
            return {
                ...state,
                content: state.content.map(job =>
                    job.id === action.payload.jobId
                        ? {
                              ...job,
                              bookings: job.bookings.map(booking =>
                                  booking.id === action.payload.id
                                      ? {
                                            ...booking,
                                            ...action.payload.data,
                                        }
                                      : booking,
                              ),
                              booking:
                                  job.booking &&
                                  job.booking.id === action.payload.id
                                      ? {
                                            ...job.booking,
                                            ...action.payload.data,
                                        }
                                      : job.booking,
                          }
                        : job,
                ),
            };
        default:
            return state;
    }
};

export default reducer;
